// Remove service workers e caches deixados por versões antigas do site (PWA do catálogo
// legado / CRA com service worker). Este app NÃO usa service worker: se algum estiver
// registrado nesta origem, ele serve o index.html antigo do cache e o usuário vê o layout
// velho até forçar o recarregamento (Ctrl+Shift+R ignora o service worker).
//
// Complementa public/sw.js e public/service-worker.js ("kill switch"), que limpam o
// worker antigo mesmo quando a página antiga ainda é a que está sendo servida.

const RELOAD_FLAG = "sw_cleanup_reloaded";

export const unregisterServiceWorkers = async () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    if (registrations.length === 0) {
      sessionStorage.removeItem(RELOAD_FLAG);
      return;
    }

    await Promise.all(registrations.map((r) => r.unregister()));

    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }

    console.warn(
      `⚠️ ${registrations.length} service worker(s) antigo(s) removido(s) e caches limpos.`
    );

    // A página atual ainda pode ter vindo do worker antigo: recarrega uma única vez
    if (navigator.serviceWorker.controller && !sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, "1");
      window.location.reload();
    }
  } catch (e) {
    console.error("❌ Erro ao remover service workers antigos:", e);
  }
};
